import { FC } from 'react';
import './style.less';

export type IphoneBottomAdaptiveProps = {
  bgColor?: string;
};

export const IphoneBottomAdaptive: FC<IphoneBottomAdaptiveProps> = (props) => {
  return (
    <div
      className="safe-area-inset-bottom"
      style={props.bgColor ? { backgroundColor: props.bgColor } : {}}
    ></div>
  );
};
